import { withNamespaces } from "react-i18next";

import "./style.scss";

/**
 * Renders the AI suggestion + reason card for a questionnaire question.
 * Presentation only — no lookup or business logic.
 *
 * @param {Object} props
 * @param {string} props.reason
 * @param {Function} props.t
 */
const QuestionnaireAiSuggestion = ({ reason, t }) => {
    if (!reason) {
        return null;
    }

    return (
        <div className="questionnaire-ai-suggestion" role="status">
            <div className="questionnaire-ai-suggestion__header">
                <span className="questionnaire-ai-suggestion__badge">
                    {t("AI suggested")}
                </span>
                {/* <span className="questionnaire-ai-suggestion__why">
                    {t("Why this answer?")}
                </span> */}
            </div>

            <div className="questionnaire-ai-suggestion__reason">
                <div className="questionnaire-ai-suggestion__reason-title">
                    {t("AI Reason")}
                </div>
                <div className="questionnaire-ai-suggestion__reason-text">
                    {reason}
                </div>
            </div>
        </div>
    );
};

export default withNamespaces()(QuestionnaireAiSuggestion);
